export function getMobilePlatformType() {
    const useragent = navigator.userAgent;

    if (useragent.match(/android/i)) {
        return 'android';
    }
    if (useragent.match(/iPhone/i)) {
        return 'ios';
    }
    return '';
}
